import { Action, createReducer, on } from '@ngrx/store';

import { Calendar } from 'src/app/model/calendar';
import { CalendarException } from 'src/app/model/calendar-exception';
import * as CalendarActions from './calendar.actions';


export interface State {
    calendarsLoading: boolean;
    calendars: Calendar[];
    calendarAdded: boolean;
    calendarAdding: boolean;
    calendarEdited: boolean;
    calendarEditing: boolean;
    exceptions: CalendarException[];
}
export const initialState: State = {
    calendarsLoading: false,
    calendars: [],
    calendarAdded: false,
    calendarAdding: false,
    calendarEdited: false,
    calendarEditing: false,
    exceptions: [],
};

const scheduleReducer = createReducer(
    initialState,
    on(CalendarActions.getCalendars, (state) => ({ ...state, calendarsLoading: true })),
    on(CalendarActions.getCalendarsSuccess, (state, payload) => ({
        ...state,
        calendars: payload.calendars,
        calendarsLoading: false
    })),
    on(CalendarActions.getCalendarsFailed, (state) => ({ ...state, calendarsLoading: false })),
    on(CalendarActions.resetCalendarDialog, (state) => ({
        ...state,
        calendarAdded: false, calendarAdding: false, calendarEdited: false, calendarEditing: false,
    })),
    on(CalendarActions.addCalendar, (state) => ({ ...state, calendarAdding: true, calendarAdded: false })),
    on(CalendarActions.addCalendarSuccess, (state, payload) => ({
        ...state,
        calendars: [...state.calendars, payload.calendar],
        calendarAdding: false, calendarAdded: true
    })),
    on(CalendarActions.addCalendarFailed, (state) => ({ ...state, calendarAdded: false, calendarAdding: false })),
    on(CalendarActions.editCalendar, (state) => ({ ...state, calendarEditing: true, calendarEdited: false })),
    on(CalendarActions.editCalendarSuccess, (state, payload) => {
        const cals = state.calendars.filter(cal => cal.Id !== payload.calendar.Id);
        return {
            ...state,
            calendars: [...cals, payload.calendar],
            calendarEditing: false, calendarEdited: true
        };
    }),
    on(CalendarActions.editCalendarFailed, (state) => ({ ...state, calendarEditing: true, calendarEdited: false })),
    on(CalendarActions.deleteCalendarSuccess, (state, payload) => ({
        ...state,
        calendars: state.calendars.filter(e => e.Id !== payload.id),
    })),
    on(CalendarActions.getExceptionsSuccess, (state, payload) => ({
        ...state,
        exceptions: payload.exceptions,
    })),
    on(CalendarActions.addExceptionSuccess, (state, payload) => ({
        ...state,
        exceptions: [...state.exceptions, payload.exception],
    })),
    on(CalendarActions.deleteExceptionSuccess, (state, payload) => ({
        ...state,
        exceptions: state.exceptions.filter(e => e.Id !== payload.id),
    })),
);

export const reducer = (state: State | undefined, action: Action): State => scheduleReducer(state, action);
